import { createApp } from "vue";

import App from "./App.vue";
import router from "./router/index";
import "@/assets/scss/app.scss";
import store from "./store";
import Breadcrumbs from "./components/bread_crumbs";
import VueApexCharts from "vue3-apexcharts";
import "bootstrap";
import settingPage from "./components/settingPage.vue";
import DropZone from "dropzone-vue";
import "bootstrap/dist/js/bootstrap.bundle";
import PerfectScrollbar from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import Toaster from "@meforma/vue-toaster";
import Vue3Tour from "vue3-tour";
import "vue3-tour/dist/vue3-tour.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import bcard from "./components/b-card.vue";
import Vue3Toasity from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import VueAnimateOnScroll from "vue3-animate-onscroll";
import { quillEditor } from "vue3-quill";
import Lightbox from "vue-easy-lightbox";
import { VueMasonryPlugin } from "vue-masonry";
import vue3StarRatings from "vue3-star-ratings";
import Datepicker from "vue3-datepicker";
import VueNumber from "vue-number-animation";
import SimpleTypeahead from "vue3-simple-typeahead";
import "vue3-simple-typeahead/dist/vue3-simple-typeahead.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import pt from "./locales/fr.json";
import fr from "./locales/pt.json";
import es from "./locales/es.json";
import { defaultLocale, localeOptions } from "./constants/config";
import Toast, { POSITION, useToast } from "vue-toastification";
import "vue-toastification/dist/index.css";

import PrimeVue from "primevue/config";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import AutoComplete from "primevue/autocomplete";

import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";

import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "@popperjs/core";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import {
  fab,
  faFacebook,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import axios from "axios";
import { global } from "./global";

axios.defaults.baseURL = global.url;

library.add(fab, fas, faFacebook, faInstagram, faTwitter);

const messages = { en: en, es: es, pt: pt, fr: fr };
const locale =
  localStorage.getItem("currentLanguage") &&
  localeOptions.filter((x) => x.id === localStorage.getItem("currentLanguage"))
    .length > 0
    ? localStorage.getItem("currentLanguage")
    : defaultLocale;
const i18n = createI18n({
  locale: locale,
  fallbackLocale: "en",
  messages,
  silentTranslationWarn: true,
});

createApp(App)
  .use(Toast)
  .use(i18n)
  .use(SimpleTypeahead)
  .use(VueMasonryPlugin)
  .use(VueNumber)
  .use(PrimeVue, {
    zIndex: {
      modal: 1100, //dialog, sidebar
      overlay: 10000, //dropdown, overlaypanel
      menu: 1000, //overlay menus
      tooltip: 1100, //tooltip
    },
  })
  .component("vue3-star-ratings", vue3StarRatings)
  .component("DataTable", DataTable)
  .component("Column", Column)
  .component("v-select", vSelect)
  .use(quillEditor)
  .use(Lightbox)
  .use(store)
  .use(VueSweetalert2)
  .use(VueAwesomePaginate)
  .use(VueAnimateOnScroll)
  .use(Vue3Toasity)
  .use(Vue3Tour)
  .use(Toaster)
  .use(Vuetify)
  .use(router)
  .component("settingPage", settingPage)
  .component("b-card", bcard)
  .use(PerfectScrollbar)
  .use(DropZone)
  .component("multiselect", Multiselect)
  .component("Breadcrumbs", Breadcrumbs)
  .component("apexchart", VueApexCharts)
  .use(require("vue-chartist"))
  .component("Datepicker", Datepicker)
  .component("font-awesome-icon", FontAwesomeIcon)
  .component("AutoComplete", AutoComplete)
  .mount("#app");
